import { render } from 'preact';
import { App } from './app';
import './estilos.css';
render(<App />, document.getElementById('app')!);
